import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import {TextToSpeech} from '@ionic-native/text-to-speech'; 

/*
  Generated class for the TexttospeechProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class TexttospeechProvider {

  constructor(public tts: TextToSpeech) {
    console.log('Hello TexttospeechProvider Provider');
  }

/**
 * Spricht den übergebenen Text
 * 
 * @param {string} speakThisText  Der Text, der gesprochen werden soll
 * @returns {Promise<any>} 
 * @memberof TexttospeechProvider
 */
public async speakText(speakThisText:string):Promise<any>{

    try{
      this.tts.stop();
            // await this.tts.speak(this.text);

await this.tts.speak({
            text: speakThisText,
            locale: 'de-DE',
            rate: 1

        });

            
    }
    catch(e){
      console.log('Fehler in TexttospeechProvider: ' + e);
    }
}

}



// WEBPACK FOOTER //
// ./src/providers/texttospeech/texttospeech.ts